<template>
  <v-row
    no-gutters
    align="center"
    class="pagination-bar"
  >
    <v-col
      v-if="hasActions"
    >
      <slot name="action" />
    </v-col>
    <v-col
      v-if="total && showCounts"
      class="pl-2 caption font-weight-light"
      :cols="hasActions ? 'auto' : undefined"
    >
      Showing
      <span class="font-weight-medium">
        {{ from }} - {{ to }}
      </span>
      of
      <span class="font-weight-medium">
        {{ total }}
      </span>
      results
    </v-col>
    <v-col cols="auto">
      <v-pagination
        v-if="lastPage > 1"
        v-model="pageDirty"
        :total-visible="totalVisiblePages"
        :length="lastPage"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      from: {
        type: Number,
        default: 0
      },
      to: {
        type: Number,
        default: 0
      },
      total: {
        type: Number,
        default: 0
      },
      lastPage: {
        type: Number,
        default: 1
      },
      page: {
        type: Number,
        default: 1
      },
      showCounts: {
        type: Boolean,
        default: true
      },
      hasActions: {
        type: Boolean,
        default: false
      },
      totalVisible: {
        type: Number,
        default: 10
      }
    },
    computed: {
      pageDirty: {
        get: function () {
          return this.page
        },
        set: function (val) {
          this.$emit('update:page', val)
        }
      }
    },
    created() {
      let maxPages = 10

      if (this.$vuetify.breakpoint.xsOnly) maxPages = 5

      this.totalVisiblePages = this.totalVisible > maxPages ? maxPages : this.totalVisible
    }
  }
</script>
